import { render } from "./ModalConfirm.vue?vue&type=template&id=c0a5b0b0&scoped=true&ts=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts"

import "./ModalConfirm.vue?vue&type=style&index=0&id=c0a5b0b0&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0a5b0b0"]])

export default __exports__